<template>
  <div class="aboutus">
    <div class="aboutus-box">
      <div class="title">{{ $t("route.aboutus") }}</div>
      <!-- 轮播图 -->
      <swiper
        class="swiper"
        :options="swiperOption"
        v-if="aboutUsList.length !== 0"
      >
        <!-- 第一张轮播图-公司介绍 -->
        <swiper-slide class="one">
          <div class="title-img"></div>
          <div class="img-box">
            <img
              :src="aboutUsList.detailsPicture1 | OSSUrl"
              lazy-load
            />
            <img
              class="big-img"
              :src="aboutUsList.detailsPicture2 | OSSUrl"
              lazy-load
            />
            <img
              :src="aboutUsList.detailsPicture3 | OSSUrl"
              lazy-load
            />
          </div>
          <div class="text-box">{{ aboutUsList.details }}</div>
        </swiper-slide>
        <!-- 第二张轮播图-技术优势 -->
        <swiper-slide class="one two">
          <div class="title-img"></div>
          <div class="img-box">
            <img
              :src="aboutUsList.detailsPicture4 | OSSUrl"
              lazy-load
            />
          </div>
        </swiper-slide>
        <!-- 第三张轮播图-合作伙伴 -->
        <swiper-slide class="one three">
          <div class="title-img"></div>
          <div class="img-box">
            <img
              :src="aboutUsList.detailsPicture5 | OSSUrl"
              lazy-load
            />
          </div>
        </swiper-slide>
        <swiper-slide class="one four">
          <div class="title-img"></div>
          <div class="img-box">
            <div class="img-sub">
              <div class="img-content">
                <img
                  @click="windowopen('company')"
                  class="big-img"
                  src="../../assets/pc/company-vr.png"
                  lazy-load
                />
              </div>

              <span>漫游优鱼</span>
            </div>

            <div class="img-sub">
              <div class="img-content">
                <img
                  @click="windowopen('base')"
                  class="big-img"
                  src="../../assets/pc/base-vr.png"
                  lazy-load
                />
              </div>

              <span>优鱼研究基地</span>
            </div>

          </div>
        </swiper-slide>
      </swiper>
      <!-- 上一张 -->
      <div
        class="swiper-button-prev"
        slot="button-prev"
      >
        <!-- svg图标 -->
        <svg
          version="1.1"
          id="图层_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 141.7 141.7"
          style="enable-background: new 0 0 141.7 141.7"
          xml:space="preserve"
        >
          <g>
            <path
              class="st0"
              d="M98.1,135.5c-2.6,0-5.1-0.9-7.1-2.8L40,83.4c-3-2.9-5-6.8-5.3-10.9c-0.4-4.8,1.3-9.4,4.6-12.9l49.4-51
		c3.7-3.8,9.8-4.4,13.9-0.9c4.4,3.8,4.7,10.5,0.7,14.6L60.9,66.1c-2.7,2.8-2.6,7.2,0.2,9.8l43.9,42.5c4,3.8,4.1,10.2,0.2,14.1
		C103.2,134.5,100.7,135.5,98.1,135.5z"
            />
          </g>
        </svg>
      </div>
      <!-- 下一张 -->
      <div
        class="swiper-button-next"
        slot="button-next"
      >
        <svg
          version="1.1"
          id="图层_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 141.7 141.7"
          style="enable-background: new 0 0 141.7 141.7"
          xml:space="preserve"
        >
          <g>
            <path
              class="st0"
              d="M44.5,135.5c2.6,0,5.1-0.9,7.1-2.8l51-49.4c3-2.9,5-6.8,5.3-10.9c0.4-4.8-1.3-9.4-4.6-12.9l-49.4-51
		C50.2,4.7,44.1,4.2,40,7.6c-4.4,3.8-4.7,10.5-0.7,14.6l42.5,43.9c2.7,2.8,2.6,7.2-0.2,9.8l-43.9,42.5c-4,3.8-4.1,10.2-0.2,14.1
		C39.4,134.5,41.9,135.5,44.5,135.5z"
            />
          </g>
        </svg>
      </div>
      <!-- 指示 -->
      <div
        class="swiper-pagination"
        slot="pagination"
      ></div>
    </div>
  </div>
</template>

<script>
import http from "../../axios/index.js";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "aboutus",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    msg: String,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1, // 轮播图显示个数
        slidesPerGroup: 1, // 滑动列数
        slidesPerColumn: 1, // 两行
        spaceBetween: 50, // 轮播图间距
        // autoplay: true, // 默认自动轮播
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      lang: "zh_CN",
      aboutUsList: [],
    };
  },
  methods: {
    windowopen(txt) {
      if (txt == "company") {
        window.open("http://company-vr.uyu1027.com/", "_blank");
      } else if (txt == "base") {
        window.open("http://uyubase-vr.uyu1027.com/", "_blank");
      }
    },
    // 获取关于我们数据
    getAboutUsList() {
      const url = `/frontAboutUs/${this.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.aboutUsList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.lang = "zh_CN";
      } else {
        this.lang = "en";
      }
      this.aboutUsList = [];
      this.getAboutUsList(); // 获取关于我们数据
    },
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.lang = "en";
    }
    this.getAboutUsList(); // 获取关于我们数据
  },
};
</script>
<style lang="less" scoped>
.aboutus {
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .aboutus-box {
    position: relative;
    width: 116.75rem;
    height: 63.75rem;
    margin-top: -0.33rem;

    .title {
      box-sizing: border-box;
      font-size: 1.74rem;
      // font-family: Alibaba PuHuiTi;
      font-family: Alibaba-PuHuiTi-Medium;
      font-weight: 500;
      color: #2b2b2b;
      line-height: 1.67rem;
      position: absolute;
      left: 0;
      right: 0;
      //top: 0.9rem;
      top: 1.3rem;
    }

    .swiper {
      box-sizing: border-box;
      width: 97.33rem;
      height: auto;
      margin-top: 12.24rem;

      /deep/.swiper-wrapper {
        box-sizing: border-box;
        align-content: flex-start;

        .swiper-slide {
          box-sizing: border-box;
          width: 100% !important;
          height: 100% !important;
          border-radius: 1rem;

          &.one {
            position: relative;

            .title-img {
              width: 15.92rem;
              height: 3.92rem;
              margin-bottom: 3.17rem;
              background-size: 15.92rem 3.92rem !important;
              background: url(../../assets/pc/company.png);
            }

            .img-box {
              display: flex;
              align-items: center;
              justify-content: space-between;

              img.big-img {
                box-sizing: border-box;
                width: 33.75rem;
                height: 22.92rem;
              }
            }

            .text-box {
              width: 100%;
              min-height: 6.33rem;
              font-size: 1.33rem;
              font-family: AlibabaPuHuiTi-Regular;
              // font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #2b2b2b;
              line-height: 2.5rem;
              margin-top: 4rem;
              text-align: left;
            }
          }

          &.two {
            .title-img {
              width: 21.08rem;
              height: 3.92rem;
              background-size: 21.08rem 3.92rem !important;
              background: url(../../assets/pc/technical.png);
            }
            .img-box {
              width: 100%;
              height: 30.33rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          &.three {
            .title-img {
              width: 21.08rem;
              height: 3.83rem;
              background-size: 21.08rem 3.83rem !important;
              background: url(../../assets/pc/partners.png);
            }
            .img-box {
              width: 100%;
              height: 30.33rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          &.four {
            .img-box {
              justify-content: center;
            }
            .img-sub {
              &:first-child {
                margin-right: 5rem;
              }
              .img-content {
                overflow: hidden;
                border-radius: 1rem;
              }
              .big-img {
                cursor: pointer;
                transition: all 2s;
                &:hover {
                  transform: scale(1.2);
                }
              }
              > span {
                display: inline-block;
                width: 100%;
                margin-top: 20px;
                height: 1.33rem;
                font-size: 1.33rem;
                // font-family: Alibaba PuHuiTi;
                font-family: AlibabaPuHuiTi-Regular;
                font-weight: 400;
                color: #2b2b2b;
                line-height: 2.5rem;
              }
            }
          }

          img {
            box-sizing: border-box;
            width: 27.67rem;
            height: 18.75rem;
            background: #ffffff;
            border-radius: 1rem;
          }
        }
      }
    }

    .swiper-button-prev {
      box-sizing: border-box;
      width: 6.17rem;
      height: 5.58rem;
      top: 30.58rem;
      left: 1.58rem;

      &::after {
        display: none;
      }
      .st0 {
        fill: #ffffff;
      }
    }

    .swiper-button-next {
      width: 6.17rem;
      height: 5.58rem;
      top: 30.58rem;
      right: 2.33rem;
      &::after {
        display: none;
      }
      .st0 {
        fill: #ffffff;
      }
    }

    .swiper-button-disabled {
      opacity: 1;
      .st0 {
        fill: #d9d9d9;
      }
    }

    .swiper-pagination {
      left: 0;
      right: 0;
      bottom: 2.83rem;

      /deep/.swiper-pagination-bullet {
        width: 5.17rem !important;
        height: 1rem !important;
        background: #d9d9d9;
        border-radius: 1rem;
        margin-right: 2.5rem;
      }

      /deep/.swiper-pagination-bullet-active {
        background: #ffffff;
      }
    }
  }
}
</style>

